import anime from 'animejs'

import {getOriginUrl} from '@helpers/url'
import {Component} from 'lowkey-component'
import {Pjax} from '@lib/../services/navigation/Pjax'

import {Form} from './form/Form'
import {FormStep} from './form/FormStep'

const MAIL_SENT = 'mail_sent'

type InvalidField = {
  error_id: string;
  info: string;
  message: string;
};

export class ContactForm extends Form {
  step: FormStep | null = null
  confirmBtn: Component<HTMLButtonElement> | null = null
  submitBtn: Component<HTMLButtonElement> | null = null
  resetBtn: Component<HTMLButtonElement> | null = null
  submitBtnLabel: HTMLSpanElement | null = null
  submitBtnText = ''
  thanks = ''

  _scroll() {
    const {top = 0} = this.element?.getBoundingClientRect() || {}
    const windowScrollY = window.scrollY || window.pageYOffset
    const y = top + windowScrollY
    const scroll = {y: windowScrollY}
    anime({
      duration: 800,
      easing: 'easeOutCubic',
      targets: scroll,
      update: () => {
        window.scrollTo(0, scroll.y)
      },
      y,
    })
  }

  getFormId(): string {
    return this.element?.dataset['formId'] || ''
  }

  getFormData(): FormData {
    const formData = new FormData()
    this.fields?.map((f) => {
      formData.append(f.name, f.value)
    })
    return formData
  }

  didMount() {
    super.didMount()

    this.thanks = this.element?.dataset.thanks || 'thanks'

    this.resetBtn = new Component<HTMLButtonElement>(this.element?.querySelector('.js-form-reset') as HTMLButtonElement)
    this.resetBtn.mount()
    this.confirmBtn = new Component<HTMLButtonElement>(this.element?.querySelector(
      '.js-form-confirm') as HTMLButtonElement)
    this.confirmBtn.mount()
    this.submitBtn = new Component<HTMLButtonElement>(this.element?.querySelector('.js-form-submit') as HTMLButtonElement)
    this.submitBtn.mount()
    this.submitBtnLabel = this.submitBtn.element?.querySelector(
      '.a-form-button_label',
    ) as HTMLSpanElement

    this.submitBtnText = this.submitBtnLabel?.textContent || ''
    if (this.element?.querySelector('.js-form-step')) {
      this.step = new FormStep(this.element?.querySelector('.js-form-step') as HTMLElement)
      this.step.mount()
    }

    this.confirmBtn.on('click', this.onConfirm.bind(this))
    this.submitBtn.on('click', this.onSubmit.bind(this))
    this.resetBtn.on('click', this.onReset.bind(this))

    if (this.submitBtn.element) {
      // const submitDisabled = !this.isValid;
      // this.submitBtn.element.disabled = submitDisabled;
    }

  }

  didUnmount() {
    super.didUnmount()
    this.submitBtn?.destroy()
  }

  onChange() {
    this.confirmEmail()
  }

  getApiUrl() {
    return `${getOriginUrl()}/wp-json/contact-form-7/v1/contact-forms/${this.getFormId()}/feedback`
  }

  onError() {
    this.onReset()
  }

  onReset() {
    // this._scroll()
    if (this.submitBtn) {
      this.submitBtn.element.disabled = false
    }

    this.element?.classList.remove('is-confirm')
    this.fields?.map((f) => {
      f.readonly = false
    })
    this.step && this.step.input()
  }

  onConfirm() {
    this._scroll()
    this.confirm()
    this.confirmEmail()
    const valid = this.isValid
    if (valid) {
      this.notification('')
      this.element?.classList.add('is-confirm')
      this.fields.map((f) => {
        f.readonly = true
      })
      this.step?.confirm()
    } else {
      this.notification('入力内容に誤りがあります')
    }
  }

  onSubmit() {
    const valid = this.confirm()
    if (valid) {
      this.notification('')
      const formData = this.getFormData()

      if (this.submitBtn) {
        this.submitBtn.element.disabled = true
      }
      if (this.submitBtnLabel) {
        this.submitBtnLabel.textContent = '送信中...'
      }

      fetch(this.getApiUrl(), {
        body: formData,
        method: 'POST',
      })
      .then(function (res) {
        return res.json()
      })
      .then((data) => {
        if (data.status === MAIL_SENT) {
          this.onSend(data)
        } else {
          // todo
          const fieldsError = this.getFieldsError(data?.invalid_fields)
          this.notification(`${fieldsError}\n${data.message}`)
          this.onError()
        }
        if (this.submitBtnLabel) {
          this.submitBtnLabel.textContent = this.submitBtnText
        }
      })
      .catch((e) => {
        this.onError()
        this.notification(e.message)
        if (this.submitBtnLabel) {
          this.submitBtnLabel.textContent = this.submitBtnText
        }
        // todo
      })
    } else {
      this._scroll()
      this.notification('入力内容に誤りがあります')
    }
  }

  getFieldsError(invalidFields: InvalidField[] | undefined) {
    return invalidFields?.map((field) => field.message).join('\n')
  }

  notification(message: string) {
    const element = this.element?.querySelector('.js-form-notification')
    if (element) {
      Array.from(element.children).map((child) => element.removeChild(child))
      const m = document.createElement('span') as HTMLSpanElement
      m.innerText = message
      element.appendChild(m)
    }
  }

  onSend(data: any) {
    this._scroll()
    this.notification(data.message)
    // this.element?.reset();
    if (this.submitBtn?.element) {
      this.submitBtn.element.disabled = true
    }
    const url = `${getOriginUrl()}${location.pathname}${this.thanks}`
    Pjax.create().loadUrl(url)
  }

  confirmEmail() {
    const emailConfirm = this.getByName('your-email-confirm')
    if (emailConfirm) {
      const email = this.getByName('your-email')
      if (email.validate() && emailConfirm.validate()) {
        if (email.value !== emailConfirm.value) {
          emailConfirm.setInvalid('メールアドレスと一致しておりません')
        } else {
          emailConfirm.validate()
        }
      }
    }
  }
}
